<template>
	<div class="banner">
		<div :class="['img-container', cms.bannerImgVersion]"></div>
		<div class="banner-content">
			<div class="banner-top">
				<h1>{{ cms.bannerHead }}</h1>
				<h3>{{ cms.bannerSubHead }}</h3>
				<button
					v-if="windowWidth >= mobileBreakpoint"
					type="button"
					class="btn btn-primary"
					@click="goToForm"
				>
					{{ cms.bannerRegButton }}
				</button>
			</div>
			<template v-if="windowWidth >= mobileBreakpoint">
				<div class="banner-grid">
					<div class="d-flex">
						<div v-for="(item, i) in cms.triples" :key="i">
							<img :src="'images/brands/' + item.ico + '.svg'" />
							<h4>{{ item.head }}</h4>
							<p>{{ item.txt }}</p>
						</div>
					</div>
				</div>
			</template>
			<swiper
				v-else
				:pagination="pagination"
				:modules="modules"
				class="banner-slider"
			>
				<swiper-slide
					v-for="(item, i) in cms.triples"
					:key="i"
					class="slide-item"
				>
					<img :src="'images/brands/' + item.ico + '.svg'" />
					<h4>{{ item.head }}</h4>
					<p>{{ item.txt }}</p>
				</swiper-slide>
				<div class="swiper-pagination" slot="pagination"></div>
			</swiper>
			<button
				v-if="windowWidth < mobileBreakpoint"
				type="button"
				class="btn btn-primary"
				@click="goToForm"
			>
				{{ cms.bannerRegButton }}
			</button>
		</div>
	</div>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Pagination, Scrollbar } from 'swiper/modules';
import { mapGetters } from 'vuex';
import 'swiper/css';
import 'swiper/css/pagination';

export default {
	data() {
		return {
			modules: [Pagination, Scrollbar],
			pagination: {
				clickable: true,
			},
			/* eslint-disable */
			cms: {
				bannerHead: BANNER_HEAD,
				bannerSubHead: BANNER_SUB_HEAD,
				bannerRegButton: BANNER_REG_BUTTON,
				bannerImgVersion: BANNER_IMG_VERSION,
				triples: [
					{
						head: TRIPEL_1_HEAD,
						txt: TRIPEL_1_TXT,
						ico: TRIPEL_1_ICO,
					},
					{
						head: TRIPEL_2_HEAD,
						txt: TRIPEL_2_TXT,
						ico: TRIPEL_2_ICO,
					},
					{
						head: TRIPEL_3_HEAD,
						txt: TRIPEL_3_TXT,
						ico: TRIPEL_3_ICO,
					},
				],
			},
			/* eslint-enable */
		};
	},
	components: {
		Swiper,
		SwiperSlide,
	},
	methods: {
		goToForm() {
			const element = document.getElementById('RegistrationForm');
			element.scrollIntoView({ behavior: 'smooth' });
		},
	},
	computed: {
		...mapGetters(['windowWidth', 'mobileBreakpoint']),
	},
};
</script>
